import { API, generic } from "api"

export default class CoursesService {
  static index = async ({ pageState }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_COURSES_INDEX_STATUS",
      stateDataKey: ["courses", "subscribed_courses", "course_invitations"],
      stateErrorKey: [
        "coursesErrors",
        "subscribed_coursesErrors",
        "course_invitationsErrors"
      ],
      apiEndpoint: API.students.courses.index,
      apiUrlReplacements: {},
      apiData: {},
      errorMessage: "Courses could not be fetched"
    })
  }

  static show = async ({ pageState, courseId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_COURSES_SHOW_STATUS",
      stateDataKey: ["course"],
      stateErrorKey: ["courseErrors"],
      apiEndpoint: API.students.courses.show,
      apiUrlReplacements: { courseId },
      apiData: {},
      errorMessage: "Course could not be fetched"
    })
  }

  static payment = async ({ pageState, courseId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_COURSES_PAYMENT_STATUS",
      stateDataKey: ["course", "course_subscription"],
      stateErrorKey: ["courseErrors", "courseSubscriptionErrors"],
      apiEndpoint: API.students.courses.payment,
      apiUrlReplacements: { courseId },
      apiData: {},
      errorMessage: "Payment details could not be fetched"
    })
  }
}
